import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { CreateTeamModule } from '../create-team/create-team.module';
import { TeamItemComponentModule } from '../team-item/team-item.module';
import { SelectTeamComponent } from './select-team.component';
import { EmptyPageModule } from '../../empty-page/empty-page.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TeamItemComponentModule,
        CreateTeamModule,
        EmptyPageModule,
        TranslateModule
    ],
    declarations: [
        SelectTeamComponent
    ]
})
export class SelectTeamComponentModule { }
